import React from 'react'
import { groupBy } from 'lodash-es'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { HeroPanel, BannerStatusTile, BannerTilesGroup, DetailTilesContainer, EnvironmentTitle } from 'view/shared/heroPanel'
import { Translation, Locale } from 'locale'
import { UserDetail, UserStatus } from 'api'
import { userDetailsSelector } from 'selectors/userSelectors'
import { WindowActions } from 'epics/windowEpic'

interface UsersHeroPanelProps {
  userList: UserDetail[]
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  userList: userDetailsSelector
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/admin/users')
}

const UsersHeroPanelComponent: React.FunctionComponent<UsersHeroPanelProps> = props => {
  const { userList, onTearout } = props
  const usersByStatus = groupBy(userList, userDetail => userDetail.user.status)
  const enabledUsers = usersByStatus[UserStatus.ACTIVE] || []
  const disabledUsers = usersByStatus[UserStatus.SUSPENDED] || []
  const usersByCanTrade = groupBy(userList, userDetail => userDetail.user.canTrade)
  const activeUsers = usersByCanTrade[true.toString()] || []
  const suspendedUsers = usersByCanTrade[false.toString()] || []

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'UsersHeroPanel-EnvironmentTitle'}>{Locale.translate(Translation.TC_HERO_USERS)}</EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={userList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_ACTIVE)} label={activeUsers.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_SUSPENDED)} label={suspendedUsers.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_ENABLED)} label={enabledUsers.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_DISABLED)} label={disabledUsers.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const UsersHeroPanel = connect(mapStateToProps, mapDispatchToProps)(UsersHeroPanelComponent)
